import type { Key } from "react"
import { Button, Image, Popover, Row } from "antd"
import { formatCurrency } from "@/utils/utils"
import styles from "@/styles/view-cart.module.scss"

interface CheckoutActionsProps {
  isUleeId: boolean
  paymentInfo: any
  selectedRowKeys: Key[]
  showSaveCart: boolean
  onCheckout: (_callback?: Function) => void
  onOpenPaypal: () => void
}

const CheckoutActions = ({
  isUleeId,
  paymentInfo,
  selectedRowKeys,
  showSaveCart,
  onCheckout,
  onOpenPaypal
}: CheckoutActionsProps) => {
  const saveCartEle = (
    <div className={styles['save-cart']}>
      <div className={styles['save-cart-title']}>You Save {formatCurrency(paymentInfo.totalSave)} Today!</div>
      <div className={styles['save-cart-content']}>Check out now before these deals expire!</div>
    </div>
  )

  return (
    <div
      className={styles['payment-select']}
      style={{ marginTop: showSaveCart ? '100px' : '12px' }}
      id="payment-select"
    >
      <Button
        className={styles["payment-btn"]}
        type="primary"
        href="/"
        ghost
      >Continue Shopping</Button>

      <Button
        className={`${styles["payment-btn"]} ${styles["paypal-btn"]}`}
        type="primary"
        onClick={() => { onCheckout(() => { onOpenPaypal() }) }}
      >
        <Row align="middle">
          <Image width={80} height={26} preview={false} src="https://img.crazysales.com.au/images/2022v/img/public/icon-pp-fchl.svg" alt="" />
          <div style={{ marginLeft: "12px" }}>Checkout</div>
        </Row>
      </Button>

      {
        !!(!isUleeId && (paymentInfo.total || 1) <= 4000)
        &&
        <>
          <span className={styles['or']}>OR</span>
          {
            !selectedRowKeys.length
              ?
              <Image
                alt=""
                style={{ cursor: 'pointer' }}
                src={'https://img.crazysales.com.au/images/2022v/img/public/icon-Checkout-afterpay-color.svg'}
                width={233}
                height={40}
                onClick={() => { onCheckout() }}
                preview={false}
              />
              :
              <Button
                className={`${styles["payment-btn"]} ${styles["afterpay-btn"]}`}
                type="primary"
                id="afterpayBtn"
              >
                <Image
                  alt=""
                  src={'https://img.crazysales.com.au/images/2022v/img/public/icon-Checkout-afterpay-color.svg'}
                  width={233}
                  height={40}
                  preview={false}
                />
              </Button>
          }
        </>
      }
      <span className={styles['or']}>OR</span>
      <Popover
        placement="topRight"
        content={saveCartEle}
        open={showSaveCart}
        color="#FF9F01"
        overlayInnerStyle={{ width: '350px' }}
        getPopupContainer={(triggerNode: any) => {
          const container = document.getElementById('checkout-btn-bottom')
          return container ? container : triggerNode.parentElement
        }}>
        <Button id="checkout-btn-bottom" className={styles["payment-btn"]} type="primary" onClick={() => { onCheckout(() => { window.location.href = '/checkout' }) }} >Checkout</Button>
      </Popover>
    </div>
  )
}

export default CheckoutActions
